
export default function Footer() {
  return (
    <footer className="bg-slate-900 text-white py-12">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          <div>
            <h3 className="text-2xl font-bold mb-4">VJETAR, d.o.o.</h3>
            <p className="text-slate-400 leading-relaxed">
              Protecting your digital privacy with cutting-edge VPN technology. Browse securely, stay anonymous, and enjoy internet freedom.
            </p>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <a href="#features" className="text-slate-400 hover:text-cyan-400 transition-colors cursor-pointer">
                  Features
                </a>
              </li>
              <li>
                <a href="#about" className="text-slate-400 hover:text-cyan-400 transition-colors cursor-pointer">
                  About Us
                </a>
              </li>
              <li>
                <a href="#contact" className="text-slate-400 hover:text-cyan-400 transition-colors cursor-pointer">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4">Contact Info</h4>
            <ul className="space-y-2 text-slate-400">
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line mt-1"></i>
                <span>Brace Radic 14, 21230 Sinj, Croatia</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-mail-line"></i>
                <a href="mailto:information@vjetardoo.com" className="hover:text-cyan-400 transition-colors cursor-pointer">
                  information@vjetardoo.com
                </a>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line"></i>
                <a href="tel:+13025046557" className="hover:text-cyan-400 transition-colors cursor-pointer">
                  +1 302 504 6557
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-slate-400 text-sm">
            &copy; {new Date().getFullYear()} VJETAR, d.o.o. All rights reserved.
          </p>
          <a 
            href="https://readdy.ai/?origin=logo" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="text-slate-400 hover:text-cyan-400 transition-colors text-sm cursor-pointer"
          >
            Website Builder
          </a>
        </div>
      </div>
    </footer>
  );
}
